define(
    'services/eventbroker',[
        "durandal/system",
        "durandal/app",
        "services/log"
    ],
    function(system, app, log) {

        
        // todo: consider binding events to modules other than app.js. at the moment no-one can unsubscribe from an event without turning it off for everyone.

        var trigger = function (source, event) {
            source = getSource(source);
            var args = $.makeArray(arguments).splice(2);
            log.event("%s - triggered by %o with args ", event, source, args);
            var triggerArgs = $.makeArray(arguments).splice(1);
            app.trigger.apply(app, triggerArgs); // event, args
        };
    
        var on = function (target, events, callback) {
            var subs = [];
            if (!_.isArray(events))
                events = [events];

            target = getSource(target);
            _.each(events, function (event) {
                log.event("%s - subscribed by %o ", event, target);
                var wrapper = function () {
                    var args = $.makeArray(arguments);
                    log.event("%s - received by %o with args ", event, target, args);
                    var promise = callback.apply(app, args);
                    if (!promise)
                        promise = $.Deferred().resolve();

                    promise.always(function (promisePayload) {
                        log.event("%s - completed by %o with args ", event, target, promisePayload || args);
                    });

                };

                subs.push({ subscription: app.on(event, wrapper), callback: wrapper });
            });

            return new SubscriptionGroup(subs);
        };

        var off = function (target, event) {
            target = getSource(target);

            log.event("%s - unsubscribed on %o ", event, target);
            app.off(event);
        };


        function SubscriptionGroup(subscriptions) {
            this.subscriptions = subscriptions;
        }

        SubscriptionGroup.prototype.off = function () {
            this.subscriptions.forEach(function (subscription) {
                subscription.subscription.off(null, subscription.callback);
            });
        };

        return {
            trigger: trigger,
            on: on,
            off: off
        };

        function getSource(source) {
            return typeof source == "object" ? system.getModuleId(source) || "undefined" : source;
        }

        
    });
